import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrossSellOfferDetails, NewCreditOffersEntity, OffersEntity } from '@shared/model/cross-sell.model';
import { LenderService } from '@shared/service/lender/lender.service';
import { CrossSellService } from './../../../service/cross-sell.service';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

@Component({
  selector: 'dx-cross-sell-card',
  templateUrl: './cross-sell-card.component.html',
  styleUrls: ['./cross-sell-card.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedUiLibraryModule]
})
export class CrossSellCardComponent implements OnInit {
  // Inject dependencies using the new inject pattern
  public readonly lenderService = inject(LenderService);
  public readonly crossSellService = inject(CrossSellService);

  /** Getting ApplicationId as input */
  @Input() public loanNumber: string;

  // cross sell offers
  // Properties are optional for cross-sell card
  // If both these are null, we shouldnt even render this component
  @Input() public newCreditOffers?: NewCreditOffersEntity;
  @Input() public refinanceOffers?: NewCreditOffersEntity;

  /**
   * Loan data used for display within the component
   */
  // public item: CrossSell;
  /** holds full loan */
  public item: NewCreditOffersEntity;

  /** Submitting to L360 cross sell opertunities */
  public objCrossSellOfferDetails: CrossSellOfferDetails;

  /** Trigger upload document close event */
  @Output() public ctaActionEmit = new EventEmitter<OffersEntity>();

  // Triggers full panel slide in panel for crossSell
  @Output() public openCrossSellPanel = new EventEmitter();

  /** URL to property Photo */
  // public imageUrl = '';

  /** call back msg change */
  public btnCallbackSuccess = false;
  public expirationDate = null;

  public isCollapsed = true;
  public stipulations = '';
  public stipulationList: string[] = [];
  public stipulationsShortened = false;

  // card type flag depending on the loanType of 'item'
  public isLoanCard: boolean;
  public isCreditCard: boolean;
  public isRefinanceCard: boolean;

  public openCrossSellDocModal(): void {
    this.openCrossSellPanel.emit({
      crossSellOffer: this.item,
      stipulationList: this.crossSellService.stipulationHelper(this.item?.stipulation)
    });
  }

  /**
   * On Init - set the item to the newCreditOffers or refinanceOffers
   */
  public ngOnInit() {
    this.item = this.newCreditOffers ? this.newCreditOffers : this.refinanceOffers;
    this.stipulationList = this.crossSellService.stipulationHelper(this.item?.stipulation);
    this.stipulationsShortened = this.crossSellService.displayStipulationOnSlideInPanel(this.stipulationList);
    this.expirationDate = this.item?.expirationDate ? this.item.expirationDate : null;
    this.btnCallbackSuccess = this.item?.crossSellStatusDescription.toLocaleLowerCase() === 'interested' ? true : false;
    this.item = this.crossSellService.stringReplaceCustomVar(this.item);
    this.stipulationList = this.crossSellService.stipulationListToDisplayHelper(this.stipulationList);
    this.setCrossSellCardType();
  }
  public expandCard = (): void => {
    this.isCollapsed = !this.isCollapsed;
  };

  public setCrossSellCardType(): void {
    if (this.newCreditOffers !== null && this.newCreditOffers !== undefined) {
      switch (this.item.loanType) {
        case 'Credit Card': {
          this.isCreditCard = true;
          break;
        }
        case 'Unsecured Loan': {
          this.isLoanCard = true;
          break;
        }
        case 'Auto Direct': {
          this.isRefinanceCard = true;
          break;
        }
        case 'Auto': {
          this.isRefinanceCard = true;
          break;
        }
        default: {
          this.isLoanCard = true;
          break;
        }
      }
    }
    if (this.refinanceOffers !== null && this.refinanceOffers !== undefined) {
      this.isRefinanceCard = true;
    }
  }

  /**
   * Accepts the offer and submits to L360
   */
  public acceptOffer(): void {
    const objAcceptedOffer: OffersEntity = {} as OffersEntity;

    objAcceptedOffer.applicationCrossSellDetailID = this.item.applicationCrossSellDetailId;
    objAcceptedOffer.term = this.item.decisionTerm ? this.item.decisionTerm : 0;
    objAcceptedOffer.rate = this.item.decisionRate ? this.item.decisionRate : 0;
    objAcceptedOffer.amount = this.item.decisionAmount ? this.item.decisionAmount : 0;
    objAcceptedOffer.tier = this.item.decisionTier ? this.item.decisionTier : 'A';
    objAcceptedOffer.description = this.item.description;
    objAcceptedOffer.successCallBack = () => {
      this.btnCallbackSuccess = true;
    };

    this.ctaActionEmit.emit(objAcceptedOffer);
  }
}
